import React, { useState, useRef, useEffect} from "react";
import { RouteComponentProps } from "react-router";
import { useDispatch } from "react-redux";
//import { toast } from "react-toastify";

import { ComponentStatus } from "../../components";
import { setUserSession } from "../../shared/utils/LocalSessionHandler";
import { SessionService } from "../../services";
import {
    BackImgContainer,
    WhiteTableContainer,
} from "../../components/Containers";
import { JumpBtn } from "../../components/Buttons";
import { ApplicationType, ThisPaths } from "../../shared/Constants";
import { UserInput, PasswordInput } from "../../components/Inputs";
import { Actions } from "../../app-state/actions";
import {
    useFormInput,
    useRefInput,
    useWindowDimension,
} from "../../shared/utils/CustomHooks";
import { MainLogo, UserSessionSpan } from "./MainLogo";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFingerprint } from '@fortawesome/free-solid-svg-icons';
import { env } from "../../env";

const isTotem =
    env.REACT_APP_APPLICATION_TYPE === ApplicationType.TOTEM;

const Login: React.FC<RouteComponentProps> = ({ history }) => {
    const username = useFormInput("");
    const password = useFormInput("");
    const [error, setError] = useState<string>("");
    const [status, setStatus] = useState<ComponentStatus>("complete");
    const [isInputFocused, setIsInputFocused] = useState(true);
    const dispatch = useDispatch();
    const dimensions = useWindowDimension();

    const inputRef = useRefInput(null);

    const focusInput = () => {
        if (inputRef.current) {
            inputRef.current.focus();
        }
    };

    const checkEmptyForm = () => {
        if (isTotem) return true;
        if (!username.value || !password.value) {
            setStatus("errored");
            setError("El usuario y/o contraseña no pueden estar vacios.");
            return false;
        }
        return true;
    };

    // handle button click of login form
    const handleLogin = async () => {
        if (checkEmptyForm()) {
            setStatus("loading");
            const sr = await SessionService.Login({
                username: username.value,
                password: password.value,
                backOfficeTypeCode: "CUSTOMER",
            });

            if (sr.status()) {
                setUserSession(sr.data.token!, sr.data);
                dispatch(Actions.SET_SESSION(sr.data));
                //toast.success("Login Exitoso!!");
                history.push(ThisPaths.MENU);
            } else {
                setStatus("errored");
                setError(sr.getParsedError());
                focusInput();
            }
        }
    };

    const handleChange = async (e: any) => {
        username.value += e.target.value;

        if (username.value.length == 8) {
            const value = +username.value; //para quitar los 0 delanteros
            username.value = String(value);
            handleLogin();
        }
    };

    const handleFocus = () => {
        console.log('Cambio de estado ', isInputFocused)
        setIsInputFocused(!isInputFocused);
    };


    useEffect(() =>{
        console.log('Ejecutando useEffect ', isInputFocused, inputRef.current)
        inputRef.current?.focus();
    }, [isInputFocused])


    return (
        <BackImgContainer disabledImg={window.innerWidth < 1000} inActiveHeader>
            <WhiteTableContainer
                style={
                    dimensions.height <= 667
                        ? {
                            height: (dimensions.height * 70) / 100,
                        }
                        : undefined
                }
            >
                <MainLogo />
                <UserSessionSpan>Bienvenido al Comedor</UserSessionSpan>

                {!isTotem ? (
                    <>
                        <UserInput
                            {...username}
                            placeholder="Nro. Legajo"
                            style={{ margin: "4%" }}
                        />

                        <PasswordInput
                            {...password}
                            placeholder="Contraseña"
                            style={{ margin: "4%" }}
                        />
                    </>
                ) : (
                        <>
                            <UserSessionSpan>Ingrese su huella</UserSessionSpan>
                         
                            <FontAwesomeIcon  icon={faFingerprint} size="3x" />
                            <UserInput
                                {...username}
                                autofocus={isTotem}
                                onChange={handleChange}
                                placeholder=""
                                style={{ margin: "4%" }}
                                inputRef={ inputRef }
                                handleFocus={ handleFocus }
                            />
                        </>
                    )}

                {status === "errored" && (
                    <>
                        <small style={{ color: "red" }}>{error}</small>
                        <br />
                    </>
                )}
                <JumpBtn
                    borderColor={"#0053a0"}
                    colorOnHover={"#0053a0"}
                    value={status === "loading" ? "Cargando..." : "Ingresar"}
                    onClick={handleLogin}
                    disabled={status === "loading"}
                    style={{visibility: isTotem ? "hidden" : "visible"}} 
                    // mariel
                />
                <a href={ThisPaths.FORGOT_PASSWORD} style={{ margin: "4%", visibility: isTotem ? "hidden" : "visible" }}>
                    ¿Olvidó su contraseña?
                </a>
            </WhiteTableContainer>
        </BackImgContainer>
    );
};

export default Login;
